module.exports = __webpack_public_path__ + "static/media/process.359a1542.wav";